import { FormikHelpers } from "formik";
import Modal from "src/components/Common/UI/Modal/Modal";
import FallsUnderForm from "./FallsUnderForm";
import { useCreateFallsUnder } from "./api/createFallsUnder";

const FallsUnder = ({handleCloseModal, establishmentId, fallsUnderModalVisible}: FallsUnderProps)  => {

  const createFallsUnderMutation = useCreateFallsUnder({data: {}, establishmentId});

  const initialValues: IUpdateFallsUnderForm = {
    unitType: "",
    unitID: "",
    comments: ""
  };


  const handleSubmit = async (values: IUpdateFallsUnderForm, { setSubmitting }: FormikHelpers<IUpdateFallsUnderForm>): Promise<void> => {
    try{
       await createFallsUnderMutation.mutateAsync({
      data: values,
      establishmentId: establishmentId
    })
      handleCloseModal(); 
      console.log("fallsunder", values)
    } catch (error){}

    setSubmitting(false);
    
  }

  return (
    <>
      
      <Modal
          isOpen={fallsUnderModalVisible}
          closeFilterModal={handleCloseModal}
          title={"Αντιστοίχιση σε κατάστημα ή διεύθυνση"}  
          size="md"
          >
            <FallsUnderForm initialValues={initialValues} onSubmit={handleSubmit} />
        </Modal>
    </>
  )
}

interface FallsUnderProps {
  establishmentId: number;
  handleCloseModal: () => void;
  fallsUnderModalVisible: boolean;
}

export default FallsUnder;